require("component-leaflet-map");
var matches = require("./lib/prefixed").matches;
var debounce = require("./lib/debounce");

//script globals and state
var debug = false;
var timestamp = null;
var time = Date.now();
var markers = [];
var paused = false;
var mousedown = false;
var timeout = false;
var speed = 150;

//map setup
var mapElement = document.querySelector("#earthquake-map");
var map = mapElement.map;
var L = mapElement.leaflet;

var handle = document.querySelector(".handle");
var scrubber = document.querySelector(".scrubber");

var disableZoom = function() {
  map.touchZoom.disable();
  map.doubleClickZoom.disable();
  map.boxZoom.disable();
  if (map.zoomControl && map.zoomControl._map) map.removeControl(map.zoomControl);
};

var enableZoom = function () {
  map.touchZoom.enable();
  map.doubleClickZoom.enable();
  map.dragging.enable();
  map.boxZoom.enable();
  if (!map.zoomControl._map) map.addControl(map.zoomControl);
};

map.scrollWheelZoom.disable();
map.dragging.disable();
disableZoom();

map.attributionControl.setPosition("bottomleft");
map.zoomControl.setPosition("topright");

var southWest = L.latLng(45.599, -124.167),
    northEast = L.latLng(49.218, -117.916),
    bounds = L.latLngBounds(southWest, northEast);

var isTouch = false;
try {
  document.createEvent("TouchEvent");
  isTouch = true;
} catch (e) { /* no touchscreen */ }
if (isTouch) document.querySelector(".earthquake-map .touch-cover").classList.add("activated");

//get data, load into map
var quakeData = require("./quakeData").filter(d => d.Magnitude >= 5.0 && bounds.contains(L.latLng(d.Lat, d.Lng))).sort((a,b) => a.timestamp - b.timestamp);
var years = quakeData.map(q => q.Year);
var startYear = Math.min.apply(null, years) - 1;
timestamp = startYear;

map.fitBounds([[48.995,-125],[45.845,-116.42]], {animate: false})

var makeMarker = function(quake){
  var formattedMag = quake.Magnitude.toFixed(1);
  var magClass = quake.Magnitude > 7.0 ? "m-7-0" :
                  quake.Magnitude > 6.5 ? "m-6-5" :
                  quake.Magnitude > 6.0 ? "m-6-0" :
                  quake.Magnitude > 5.5 ? "m-5-5" :
                  "m-5-0";
  var icon = new L.divIcon({ className: `quake ${magClass}` });
  var marker = L.marker([quake.Lat,quake.Lng], {icon: icon});
  marker.bindPopup(`
    <div class="popuptext">
      <div><strong>${quake.Month}/${quake.Day}/${quake.Year}</strong></div>
      <div><div class="dot ${magClass}"></div>M ${formattedMag}</div>
      <div class="small">${quake.Location ? quake.Location : "Estimated location"}</div>
    </div>
  `);
  return marker;
};

quakeData.forEach(function(q) {
  q.marker = makeMarker(q);
  q.added = false;
});

var pause = function(){
  document.querySelector(".earthquake-map .touch-cover").classList.remove("activated");
  enableZoom();
  mapElement.classList.remove("animating");
  document.querySelector(".controls").classList.add("paused");
  if (timestamp == 2016) document.querySelector(".controls").classList.add("restart");
  clearTimeout(timeout);
  emphasize(timestamp);
  timeout = false;
  paused = true;
}

var play = function(){
  if (isTouch) document.querySelector(".earthquake-map .touch-cover").classList.add("activated");
  disableZoom();
  map.fitBounds([[48.995,-125],[45.845,-116.42]])
  quakeData.forEach(function(q) {
    if (q.added) {
      q.marker._icon.style.opacity = "0.4";
      q.marker._icon.style.transform = q.marker._icon.style.transform.replace(/scale\(.*?\)/, "scale(0.8)")
    }
  });
  mapElement.classList.add("animating");
  document.querySelector(".controls").classList.remove("paused");
  document.querySelector(".controls").classList.remove("restart");
  speed = 150;
  paused = false;
  if (timestamp >= 2016) timestamp = startYear;
  time = Date.now();
  dropQuake();
}

var styleMarker = function(icon, opacity, scale) {
  icon.style.opacity = opacity;
  icon.style.transform = icon.style.transform.replace(/scale\(.*?\)/, `scale(${scale})`)
};

var emphasize = function(timestamp) {
  quakeData.forEach(function(q) {
    if (paused && q.added && q.Year == Math.floor(timestamp)) {
      styleMarker(q.marker._icon, 1, 1.8);
    } else if (paused && q.added) {
      styleMarker(q.marker._icon, .4, .8);
    }
  });
};

var showAll = function() {
  if (!paused) return;
  mapElement.classList.add("animating");
  quakeData.forEach(function(q) {
    styleMarker(q.marker._icon, 0.8, 1.2);
  });
  setTimeout(function() {
    if (!paused) return;
    mapElement.classList.remove("animating");
  }, 500)
}

var showMarker = function(quake) {
  var marker = quake.marker;
  if (quake.added) return;
  marker.addTo(map);
  quake.added = true;

  var diam = (Math.sqrt(Math.pow(10, quake.Magnitude - 1)/Math.PI)) * 2 / 8;

  var icon = marker._icon;
  var transformBefore = icon.style.transform;
  icon.style["z-index"] = Math.round(quake.Magnitude * 10);
  icon.style.transform = transformBefore + " scale(0)";
  icon.offsetWidth;
  icon.style.transform = transformBefore + ` scale(${diam/18})`;

  if (!paused) setTimeout(function(){
    styleMarker(icon, .4, .8);
  }, 500)
};

document.querySelector(".controls").addEventListener("click", function(e) {
  if (!paused) {
    pause();
  } else {
    play();
  }
});

var dropQuake = function(fromScrub) {
  if (!paused && !fromScrub) {
    var now = Date.now();
    var elapsed = now - time;
    time = now;
    var delta = elapsed / speed;
    if (debug) delta *= 10;
    timestamp += delta;

    if (timestamp > 2016) timestamp = 2016;
    
    var delta = (timestamp - startYear) / (2016 - startYear);
    handle.style.left = delta * 100 + "%";
  }
  
  document.querySelector(".date").innerHTML = Math.floor(timestamp);

  quakeData.forEach(function(q){
    if (!q.added && q.timestamp < timestamp + 1) {
      showMarker(q);
    } else if (q.added && q.timestamp > timestamp + 1) {
      map.removeLayer(q.marker);
      q.added = false;
    }
  });

  emphasize(timestamp)

  if (timestamp == 2016) {
    setTimeout(showAll, 500);
    if (!paused) pause();
  } else if (!paused) {
    timeout = setTimeout(dropQuake, 16);
  }
}

// Scrubby McScrubface

var scrub = function(e) {
  e.preventDefault();
  var bounds = scrubber.getBoundingClientRect();
  var x;
  if (e.touches) {
    x = e.touches[0].clientX - bounds.left;
  } else {
    x = e.clientX - bounds.left;
  }
  var delta = x / bounds.width;
  if (delta < 0) delta = 0;
  if (delta > 1) delta = 1;
  handle.style.left = delta * 100 + "%";
  var year = Math.floor((2016 - startYear) * delta + startYear);
  
  if (year < startYear) {
    year = startYear;
  } else if (year > 2016) {
    year = 2016;
  }

  timestamp = year;

  dropQuake(true);
};

scrubber.addEventListener("mousedown", function(e) {
  e.preventDefault();
  var wasPaused = paused;
  pause();
  //transitions should still play
  mapElement.classList.add("animating");
  var lift = function(e) {
    scrub(e);
    if (!wasPaused && timestamp !== 2016) play();
    if (paused && timestamp == 2016) pause();
    document.body.removeEventListener("mousemove", scrub);
    document.body.removeEventListener("mouseup", lift);
  }
  document.body.addEventListener("mousemove", scrub);
  document.body.addEventListener("mouseup", lift);
});

scrubber.addEventListener("touchstart", function(e) {
  e.preventDefault();
  var wasPaused = paused;
  pause();
  //transitions should still play
  mapElement.classList.add("animating");
  var lift = function() {
    if (!wasPaused && timestamp !== 2016) play();
    document.body.removeEventListener("touchmove", scrub);
    document.body.removeEventListener("touchend", lift);
  };
  document.body.addEventListener("touchmove", scrub);
  document.body.addEventListener("touchend", lift);
});

dropQuake();

